export default "__VITE_ASSET__BPkk4MDL__"